//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getuid, setuid } from '@/api/miniProgramManagement.js';
import qrcode from '../components/qrCode.vue';
export default {
  components: {
    qrcode,
  },
  data() {
    return {
      appid: '',
      tableData: [
        // {
        //   name: '开发版-开发环境',
        //   environment: 'dev',
        //   uid: '',
        //   type: '0',
        // },
        // {
        //   name: '开发版-测试环境',
        //   environment: 'test',
        //   uid: '',
        //   type: '1',
        // },
        // {
        //   name: '开发版-预发布环境',
        //   environment: 'pre',
        //   uid: '',
        //   type: '2',
        // },
        {
          name: '体验版-正式环境',
          environment: 'pro',
          uid: '',
          type: '3',
        },
        {
          name: '正式版-正式环境',
          environment: 'pro',
          uid: '',
          type: '4',
        },
        {
          name: '小程序助手',
          environment: 'pro',
          uid: '',
          type: '5',
        },
      ],
      // 修改uid
      rules: {
        uid: [
          {
            validator: (rule, value, callback) => {
              if (!this.editData.uid) {
                callback();
              } else {
                if (/^\d+$/.test(this.editData.uid)) {
                  callback();
                } else {
                  callback(new Error('uid必须为数字'));
                }
              }
            },
            trigger: 'change',
          },
        ],
      },
      showEdit: false,
      editData: { uid: '' },
      // 展示二维码(开发测试)
      showCode: false,
      code: '',
    };
  },
  created() {
    this.appid = this.$route.query.appid;
    this.getuid();
  },
  methods: {
    async getuid() {
      try {
        const res = await getuid({
          appid: this.appid,
        });
        console.log(res);
        if (res?.list?.length) {
          res.list.forEach((item) => {
            this.tableData[item.type].uid = item.uid;
          });
          console.log(this.tableData);
        }
      } catch (err) {
        console.log(err);
      }
    },
    editUid(item) {
      this.editData = JSON.parse(JSON.stringify(item));
      this.$nextTick(() => {
        this.showEdit = true;
      });
    },
    closeEdit() {
      // 表单验证
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.showEdit = false;
          try {
            const { type, uid } = this.editData;
            await setuid({
              appid: this.appid,
              type,
              uid,
            });
            this.tableData[type].uid = uid;
          } catch (err) {
            console.log(err);
          }
        } else {
          console.log('uid必须为数字');
          return false;
        }
      });
    },
    openCode(item) {
      this.code = `https://admin.baike.qq.com/omsgzh/qrcode.html?uid=${item.uid}#/`;
      this.$nextTick(() => {
        this.showCode = true;
      });
    },
    proOpenCode(rowData) {
      this.$refs.qrcode.opencode(rowData);
    },
  },
};
